import axios from 'axios';
import Cookie from 'cookies-js';
import jwt from 'jsonwebtoken';
import config from '../../../config/index';
import routes from '../../../constants/routes';
import { GET_MT_LIP_INVESTMENT } from '../../types';

// Reducer object dispenser
const getUserMtLip = MtLip => ({
  type: GET_MT_LIP_INVESTMENT,
  MtLip
});

const fetchMtLip = () => (dispatch) => {
  const token = Cookie.get('jwtToken');
  const decodeToken = jwt.decode(token);
  const { customerId } = decodeToken;

  return axios.get(
    `${config.apiUrl}${routes.GETMTLIPINVEST}/${customerId}`,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  ).then((response) => {
    const {
      mtlips,
      isSuccessful
    } = response.data;
    
    if (isSuccessful) {
      dispatch(getUserMtLip(mtlips));
    }
  }).catch((error) => {
    throw error;
  });
};

export default fetchMtLip;
